module.exports = __webpack_public_path__ + "static/homepage_hero3-34345adb35b4272a0eb198306d41ec3d.jpg";